import React from 'react';
import { Link } from 'react-router-dom';

var Footer = (props) =>
    <footer class="mdl-mega-footer">
        <div class="mdl-mega-footer--middle-section">
            <div class="mdl-mega-footer--drop-down-section">
                <input class="mdl-mega-footer--heading-checkbox" type="checkbox" checked/>
                <h1 class="mdl-mega-footer--heading">Pages</h1>
                <ul class="mdl-mega-footer--link-list">
                    {
                        props.pages.map(
                            (page) => <li><Link key={page.path} to={page.path}>{page.label}</Link></li>
                        )
                    }
                </ul>
            </div>
            <div class="mdl-mega-footer--drop-down-section">
                <input class="mdl-mega-footer--heading-checkbox" type="checkbox" checked/>
                <h1 class="mdl-mega-footer--heading">Contacts</h1>
                <ul class="mdl-mega-footer--link-list">
                    <li><a href="mailto:joao.seco@fct.unl.pt">Contact us</a></li>
                    <li><a href="http://www.di.fct.unl.pt" target="_blank" rel="noopener noreferrer">Department</a></li>
                    <li><a href="http://nova-lincs.di.fct.unl.pt" target="_blank" rel="noopener noreferrer">NOVA-LINCS <img src={"nova-lincs-small.jpg"} alt={"novalincs"}/></a></li>
                </ul>
            </div>
            {/*<div class="mdl-mega-footer--drop-down-section">
                <input class="mdl-mega-footer--heading-checkbox" type="checkbox" checked/>
                <h1 class="mdl-mega-footer--heading">FAQ</h1>
                <ul class="mdl-mega-footer--link-list">
                    <li><a href="#">Questions</a></li>
                    <li><a href="#">Answers</a></li>
                    <li><a href="#">Contact us</a></li>
                </ul>
            </div>*/}
        </div>
        {/* <div class="mdl-mega-footer--bottom-section">
            <div class="mdl-logo">
                More Information
            </div>
            <ul class="mdl-mega-footer--link-list">
                <li><a href="https://developers.google.com/web/starter-kit/">Web Starter Kit</a></li>
                <li><a href="#">Help</a></li>
                <li><a href="#">Privacy and Terms</a></li>
            </ul>
        </div>*/}
    </footer>;

export default Footer;